<p class="copy">
  &copy;{{currentYear}}
  <span *ngFor="let item of copy; let i = index" class="inline-block">
    <ng-container *ngIf="('lang' | translate) == 'en' && i == 0">
      {{item}}
    </ng-container>
    <ng-container *ngIf="('lang' | translate) == 'es' && i == 1">
      {{item}}
    </ng-container>
    <ng-container *ngIf="('lang' | translate) == 'pt' && i == 2">
      {{item}}
    </ng-container>
  </span>
</p>
